import { isEmptyString } from '@vy/utils';
import { getAccountId } from '../services/user-auth';

const AU10TIX_ACCOUNT_ID = '64fdb3f61ea951a268be3c84';

const ELIGIBLE_ACCOUNT_IDS = [AU10TIX_ACCOUNT_ID];

export function supportsLegacyErpId(): boolean {
  const accountId = getAccountId();

  if (isEmptyString(accountId)) {
    return false;
  }

  return ELIGIBLE_ACCOUNT_IDS.includes(accountId);
}
